import { useTranslation } from 'react-i18next';

const LOGO_URL = 'https://public.readdy.ai/ai/img_res/35fd5ae9-1c15-4531-8095-53366e83f94d.png';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ec972127fe8deac6a52a1bab7d3342b2.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/70 via-navy-800/40 to-navy-900/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-8">

        {/* Top badge */}
        <div className="text-center mb-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('hero.title1')}<br />
            <span className="text-turquoise-300">{t('hero.title2')}</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-2">
            {t('hero.description')}
          </p>
          <p className="text-base text-white/70 max-w-2xl mx-auto">
            {t('hero.subtitle')}
          </p>
        </div>

        {/* CTA */}
        <div className="flex justify-center mt-5 mb-8">
          <a
            href="#contact"
            className="px-10 py-4 bg-gradient-to-r from-coral-500 to-coral-600 hover:from-coral-600 hover:to-coral-700 text-white text-base font-semibold rounded-xl shadow-xl hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer"
          >
            {t('nav.bookNow')}
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-8 text-white/90">
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-line text-2xl text-turquoise-300"></i>
            <span className="text-sm font-medium">{t('hero.fullyInsured')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-customer-service-2-line text-2xl text-turquoise-300"></i>
            <span className="text-sm font-medium">{t('hero.personalService')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-map-pin-line text-2xl text-turquoise-300"></i>
            <span className="text-sm font-medium">{t('hero.basedHyeres')}</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#fleet" className="w-10 h-10 flex items-center justify-center text-white/70 hover:text-white cursor-pointer">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}
